import { type StatementDetails } from "@digits-graphql/frontend/graphql-bearer"
import { isCategoryDetails } from "src/frontend/components/Shared/Layout/Components/Statements/toDetailsData"

export function useBalanceDetails(details?: StatementDetails | null) {
  return isCategoryDetails(details) && !!details.hover.balance
}
